import { moveToFulfilled } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { AnalyticsTopResultsActivityLoadAction } from '../../domains/analyticsTopResultsActivity/actions.types';
import type { EmployeesTopThreadsLoadFulfilledAction } from '../../domains/employeesTopThreads/actions.types';

import type { AnalyticsTopResultsEntitiesLifecycle } from './types';

export type AnalyticsTopResultsAction = AnalyticsTopResultsActivityLoadAction | EmployeesTopThreadsLoadFulfilledAction;

const initialState: AnalyticsTopResultsEntitiesLifecycle = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<AnalyticsTopResultsEntitiesLifecycle, AnalyticsTopResultsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'EMPLOYEES_TOP_THREADS.LOAD_FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload.entities.analyticsTopResultsActivity });
    default:
      return state;
  }
};

export default reducer;
